import { FC, useEffect } from 'react'
//components
import { useRecoilState, useSetRecoilState } from 'recoil'
import { getProductByInquiryCode } from '../../../api/contracts'
import { postVerifyCode, putInquiryCode } from '../../../api/verify'
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useRequestFailed } from '../../../hooks/useRequestFailed'
import { useSendMessage } from '../../../hooks/useSendMessage'
import {
  inputState,
  inputtedEmailState,
  isInViewFooterState,
  onetimeKeyState,
  productsState,
  stepState,
} from '../../../states/messageState'
import { isEmail } from '../../../util/validation'
import { FooterContent } from '../FooterContent'
import { InputAndSubmitButton } from '../InputAndSubmitButton'

const VERIFY_CODE_COUNT = 36

export const InquiryCodeOrEmail: FC<{ id: string }> = (props) => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()
  const { requestFailed } = useRequestFailed()

  const [input, setInput] = useRecoilState(inputState)

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setProducts = useSetRecoilState(productsState)
  const setCurrentStep = useSetRecoilState(stepState)
  const setInputtedEmail = useSetRecoilState(inputtedEmailState)
  const setOnetimeKey = useSetRecoilState(onetimeKeyState)

  /**メールか保証番号 */
  const handleSubmitInquiryCodeOrEmail = async () => {
    setIsInViewFooter(false)
    setInput('')

    await handleAddSenderParent('user', input)
    if (isEmail(input)) {
      //メールアドレスを使った処理
      await postVerifyCode({ email: input })
      setInputtedEmail(input)
      await handleAddSenderParent('bot', `${input}に送信された一時的な6桁のコードを入力してください`)

      handleInViewFooter()
      setCurrentStep('inputVerifyCode')
    } else {
      //保証番号を利用した処理
      handleSubmitInquiryCode(input)
    }
  }

  const handleSubmitInquiryCode = async (input: string) => {
    try {
      if (input.length !== VERIFY_CODE_COUNT) throw new Error()

      const { onetimeKey } = await putInquiryCode({
        contractInquiryCode: input,
      })
      const product = await getProductByInquiryCode(input, onetimeKey)
      await handleAddSenderParent('bot', `こちらの保証契約で申請を進めてよろしいでしょうか？`)
      setProducts((prev) => [...prev, product])
      setOnetimeKey(onetimeKey)
      handleInViewFooter()
      setCurrentStep('chooseProduct')
    } catch {
      //保証番号認証失敗
      await requestFailed()
    } finally {
      setInput('')
    }
  }

  // 保証番号がURLに含まれている場合
  if (props.id) {
    useEffect(() => {
      const init = async () => {
        setIsInViewFooter(false)
        await handleAddSenderParent('user', props.id)
        handleSubmitInquiryCode(props.id)
      }

      init()
    }, [])
  }

  return (
    <FooterContent isWide>
      <InputAndSubmitButton
        value={input}
        placeholder="保証番号orメールアドレス"
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSubmitInquiryCodeOrEmail()}
        onClick={handleSubmitInquiryCodeOrEmail}
      />
    </FooterContent>
  )
}
